import React from 'react';

/**
 * Modal de confirmação para exclusão de execução de teste.
 * Segue o padrão visual dos modais de exclusão de ciclo.
 */
const DeleteExecutionModal = ({ isOpen, onClose, onConfirm, execution }) => {
  if (!isOpen) return null;

  const label = execution?.name ? `${execution.name}` : 'Execução';
  const idLabel = execution?.id ? ` (ID: ${execution.id})` : '';

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Excluir execução</h2>
          <button className="modal-close" onClick={onClose}>✕</button>
        </div>
        <div className="modal-body">
          <p>
            Tem certeza que deseja excluir a execução <strong>{label}</strong>{idLabel}?
          </p>
          <div style={{
            marginTop: 12,
            padding: '12px 14px',
            border: '1px solid #fca5a5',
            background: '#fef2f2',
            color: '#7f1d1d',
            borderRadius: 6
          }}>
            <strong>Atenção:</strong> Esta ação é permanente e <strong>não pode ser desfeita</strong>.<br/>
            Somente execuções com status <strong>planejado</strong> ou <strong>pausado</strong> podem ser excluídas.
          </div>
        </div>
        <div className="modal-actions" style={{ padding: 20 }}>
          <button type="button" className="btn btn-secondary" onClick={onClose}>Cancelar</button>
          <button type="button" className="btn btn-danger" onClick={onConfirm}>🗑️ Excluir</button>
        </div>
      </div>
    </div>
  );
};

export default DeleteExecutionModal;
